import type { BoardLabel, BoardLayout } from "./boardLayout";
import type { MotionFrame } from "./motion";
import { OPTION_LABEL_COLOR } from "./options";

/**
 * The board's labels for this frame: an option's label appears with its
 * pop-in and brightens while its word button (or node) is hovered; the old
 * options' labels fade out with them.
 */
export function boardLabelsFor(
  layout: BoardLayout,
  frame: Pick<MotionFrame, "optionScale" | "ghosts">,
  hovered: string | null,
  hoverColor: string,
): BoardLabel[] {
  const fresh = new Set(
    layout.options.filter((o) => !o.existing).map((o) => o.id),
  );
  const out: BoardLabel[] = [];
  for (const l of layout.labels) {
    if (!fresh.has(l.id)) {
      out.push(l);
      continue;
    }
    const s = frame.optionScale(l.id);
    if (s <= 0) continue;
    out.push({
      ...l,
      opacity: Math.min(1, s),
      color: hovered === l.id ? hoverColor : l.color,
    });
  }
  for (const g of frame.ghosts) {
    if (!g.label) continue;
    out.push({
      id: `ghost-${g.id}`,
      text: g.id,
      fontSize: g.label.fontSize,
      x: g.label.x,
      y: g.label.y,
      slot: "below",
      box: { x: g.label.x, y: g.label.y, w: 0, h: 0 },
      opacity: g.opacity,
      color: OPTION_LABEL_COLOR,
    });
  }
  return out;
}
